import { getUserCulture } from 'utils/UserCulture';

// import { numberParser } from "globalize/dist/globalize/number";
// should we be making use of?
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat ?

/**
 * Convert a string value to a numeric value, with some fallback enforcement.
 * @param value to convert
 * @param float true if target is a floating point number
 * @param nullable true if the value should be allowed to be null
 */
export function parseInputToNumber(value: string, float = false, nullable = false) {
  const decimal = getUserCulture().NumberDecimalSeparator;
  if (!value) {
    return nullable ? null : '0';
  }

  if (value === '-' || value === '0-') {
    // they are entering a negative number, let them do it
    return '-';
  }

  if (float && (hasTrailingDecimal(value) || value.lastIndexOf('0') === value.length - 1)) {
    return value; // they are probably still editing this, just wait
  }

  let val = getNumberFromFormattedString(value, float, nullable);
  return (isNaN(val) ? 0 : val).toString().replace('.', decimal);
}

export function cleanTrailingDecimals(value: string) {
  const decimal = getUserCulture().NumberDecimalSeparator;
  return value.indexOf(decimal) === value.length - 1 ? value.slice(0, value.length - 1) : value;
}

export function hasTrailingDecimal(value: string) {
  const decimal = getUserCulture().NumberDecimalSeparator;
  // it's very likely that a trailing decimal indicates the user is still typing.
  return value.lastIndexOf(decimal) === value.length - 1 || value.search(new RegExp(`\\${decimal}\\W`, 'g')) > -1;
}

/**
 * Initialize a default value for a numeric field based on whether it is nullable or not.
 * @param value to null check
 * @param nullable true if the value is nullable
 */
export function initializeNumericValue(value: string | null, nullable = false) {
  value = value === null ? '' : value;
  return !nullable && !value ? '0' : value;
}

// regex for numeric and group formatting separators, but not together:
// [0-9]+(\.|,[0-9]{1,2})?

export function getNumberFromFormattedString(value: string, float = false, nullable = false) {
  // return numberParser()(value);
  const decimal = getUserCulture().NumberDecimalSeparator;
  let radix = 10;
  // removing decimals instead of ignoring everything after them in parseInt
  return float ? parseFloat(value.replace(decimal, '.')) : parseInt(value.replace(decimal, ''), radix);
}
